/*
Schema for server's errors
{
  message: 'ajax error 401',
  xhr: {},
  request: {
    async: true,
    crossDomain: false,
    withCredentials: false,
    headers: {},
    method: 'POST',
    responseType: 'json',
    timeout: 0,
    url: '/api/',
    body: null,
  },
  status: 401,
  responseType: 'json',
  response: {
    code: 401,
    message: 'Usuario y/o clave incorrectos',
  },
}
*/

import { of } from 'rxjs'

import { NOTIFICATIONS_STATUS } from 'notifications'
import System from 'system'

import serverResponse from '../serverResponse'

const createErrorMessage = (
  msg = 'Parece que la conexión se interrumpió. Por favor, inténtalo nuevamente.',
  id = 'SYSTEM_ERROR',
) => (
  <div>
    {msg}
    <div style={{ fontSize: '0.55em', textAlign: 'right' }}>@{id}</div>
  </div>
)

const epicErrorHandler =
  (actionFunction, originalAction = {}, debug = process.env.NODE_ENV === 'development') =>
  (requestError) => {
    const defaultError = {
      code: 570,
      response: { code: 570 },
      trace: '',
      xhr: {},
    }
    const error = {
      ...defaultError,
      ...(requestError || {}),
    }

    if (!error.response) {
      error.response = defaultError.response
    }

    const defaultMsg =
      error.status === 401
        ? 'Acceso no verificable'
        : 'Parece que la conexión se interrumpió. Por favor, inténtalo nuevamente.'
    const msg =
      error.response?.error?.message ||
      error.response?.message ||
      (!error.message?.includes('ajax error') && error.message) ||
      defaultMsg

    const errorPayload = {
      ...error,
      code: error.status || error.code || error.response.error.code,
      message: msg,
      msg,
      response: error?.xhr?.response || error.response,
      trace: error.response?.error?.trace || '',
    }

    const currentAction =
      actionFunction(
        serverResponse(
          { error: errorPayload },
          {
            loaded: true,
            originalAction,
          },
        ),
      ) || {}

    if (debug) {
      // eslint-disable-next-line no-console
      console.error(requestError)
    }

    const notification = currentAction.notification || originalAction.notification || {}
    const id = error.status === 401 ? 'Seguridad' : notification.id || notification.type || 'SYSTEM_ERROR'

    // Make it more visual when not customized
    if (!notification.id) {
      errorPayload.msg = createErrorMessage(errorPayload.msg, id)
    }

    if (process.env.NODE_ENV === 'development' && notification.children !== errorPayload.msg) {
      notification.msg = [notification.children, ' -|- ', errorPayload.msg]
    }

    System.addNotification({
      ...notification,
      id,
      children: errorPayload.msg,
      dismissAfter: 10000,
      status: error.status === 401 ? NOTIFICATIONS_STATUS.WARNING : NOTIFICATIONS_STATUS.ERROR,
    })

    return of(currentAction)
  }

epicErrorHandler.createErrorMessage = createErrorMessage

export default epicErrorHandler
